import { takeEvery, call, put } from 'redux-saga/effects';
import _ from 'lodash';

import { firestore, getTenantPath } from '../utils/firebase';
import { convertCollection } from '../utils/helper';
import { fetchLabelFormatsRoutine } from '../routines';

function* watchFetchLabelFormatsSaga() {
  // run fetchDataFromServer on every trigger action
  yield takeEvery(fetchLabelFormatsRoutine.TRIGGER, fetchLabelFormatsSaga);
}

function fetchLabelFormats() {
  return firestore.collection(getTenantPath('/labelformats'))
    .get()
    .then(convertCollection)
    .then((data) => _.pickBy(data, (value) => !value.deleted));
}

function* fetchLabelFormatsSaga() {
  try {
    // trigger request action
    yield put(fetchLabelFormatsRoutine.request());
    // perform request to '/some_url' to fetch some data
    const labelFormats = yield call(fetchLabelFormats);
    // if request successfully finished
    yield put(fetchLabelFormatsRoutine.success({ success: true, labelFormats }));
  } catch (err) {
    console.error(err);
    // if request failed
    yield put(fetchLabelFormatsRoutine.failure({ success: false }));
  } finally {
    // trigger fulfill action
    yield put(fetchLabelFormatsRoutine.fulfill());
  }
}

export {
  watchFetchLabelFormatsSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/labelformats.js